"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-eval */
const uuid_1 = require("uuid");
const entryVarEvaluateString_1 = __importDefault(require("../../shared/entryVarEvaluateString"));
const buildFunctionEvaluator_1 = __importDefault(require("../buildFunctionEvaluator"));
const evaluateObjectOfEntryVars_1 = __importDefault(require("../../shared/evaluateObjectOfEntryVars"));
const valueIsUndefined_1 = __importDefault(require("../../typeAssertions/valueIsUndefined"));
const valueIsNull_1 = __importDefault(require("../../typeAssertions/valueIsNull"));
const Runtime_1 = require("../../types/Runtime");
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const entryVarEvaluatorContextInputData_1 = __importDefault(require("../../entryVarEvaluators/entryVarEvaluatorContextInputData"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const entryVarEvaluatePlatformOs_1 = __importDefault(require("../../shared/entryVarEvaluatePlatformOs"));
const entryVarEvaluateTagString_1 = __importDefault(require("../../shared/entryVarEvaluateTagString"));
const entryVarEvaluateLanguage_1 = __importDefault(require("../../shared/entryVarEvaluateLanguage"));
const entryVarEvaluateEntries_1 = __importDefault(require("../../shared/entryVarEvaluateEntries"));
const entryVarStringInterpolationEvaluate_1 = __importDefault(require("../../shared/entryVarStringInterpolationEvaluate"));
const entryVarEvaluateCallback_1 = __importDefault(require("../../shared/entryVarEvaluateCallback"));
const appStateSelectFC_1 = __importDefault(require("../../shared/appStateSelectFC"));
const appStateSelectRoutingStackCurrentPageId_1 = __importDefault(require("../../shared/appStateSelectRoutingStackCurrentPageId"));
const entryVarEnvironmentVariableEvaluate_1 = __importDefault(require("../../shared/entryVarEnvironmentVariableEvaluate"));
const processorGetControlListItemContextById_1 = __importDefault(require("../../shared/processorGetControlListItemContextById"));
const elementsInstruction = ({ flattedControls, controlId, propName, }) => {
    // Extract element from a control
    const controlInfo = flattedControls[controlId];
    if (!controlInfo) {
        // throw new Error(`The control with id ${controlId} was not found`)
        return undefined;
    }
    const { control } = controlInfo;
    if (!control) {
        throw new Error(`The control with id ${controlId} was not found`);
    }
    if (propName === undefined || propName === null || propName === '') {
        return control;
    }
    if (control.tag === 'switch' || control.tag === 'checkbox') {
        return (0, getValueByPathFromUnknown_1.default)(control, propName.split('.')) || false;
    }
    return (0, getValueByPathFromUnknown_1.default)(control, propName.split('.')) || undefined;
};
const evaluateVarFactoryWithProcessor = ({ store, rootProcessor, processor, functionsDefinitions, }) => {
    const evaluatorWithProcessor = ({ controlCallerId, lastFunctionsOutputs, eventOutputs, }) => {
        const evaluateEntryVar = async (entryVarDefinition) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            let entryVarDefinitionData = entryVarDefinition;
            if (Array.isArray(entryVarDefinition)) {
                // Valida si ignora o no el valor
                if (entryVarDefinition.length % 2 === 0 || entryVarDefinition.length === 1) {
                    [entryVarDefinitionData] = entryVarDefinition;
                }
                else {
                    // Puede que sea una operacion, valida cada parte
                    const values = await Promise.all(entryVarDefinition.map(evaluateEntryVar));
                    if (!values.some((value) => typeof value === 'object')) {
                        try {
                            const strValues = values.toString().replace(/,/g, '');
                            return eval(strValues);
                        }
                        catch (_j) {
                            throw new Error('This operation does not have valid operators');
                        }
                    }
                    throw new Error('This operation does not have valid operators');
                }
            }
            switch (entryVarDefinitionData.source) {
                case Runtime_1.ENTRY_VAR_SOURCE.ENVIRONMENT_VARIABLE: {
                    const evaluated = (0, entryVarEnvironmentVariableEvaluate_1.default)({
                        entryVar: entryVarDefinitionData,
                        isDevelopment: processor.root.isInDevelopment,
                        store,
                        requestDevEnvVariableFromNetwork: processor.requestDevEnvVariableFromNetwork,
                    });
                    return evaluated;
                }
                case Runtime_1.ENTRY_VAR_SOURCE.STRING_INTERPOLATION: {
                    return (0, entryVarStringInterpolationEvaluate_1.default)({
                        entryVar: entryVarDefinitionData,
                        evaluateEntryVar,
                    });
                }
                case Runtime_1.ENTRY_VAR_SOURCE.KNEX_INTERPOLATION: {
                    return entryVarDefinitionData;
                }
                case Runtime_1.ENTRY_VAR_SOURCE.ENTRIES:
                    return (0, entryVarEvaluateEntries_1.default)({
                        entriesEntryVar: entryVarDefinitionData,
                        evaluateEntryVar,
                    });
                case 'platformOS':
                    return (0, entryVarEvaluatePlatformOs_1.default)(rootProcessor);
                case Runtime_1.ENTRY_VAR_SOURCE.LANGUAGE:
                    return (0, entryVarEvaluateLanguage_1.default)(rootProcessor);
                case 'null':
                    return null;
                case 'undefined':
                    return undefined;
                case Runtime_1.ENTRY_VAR_SOURCE.CODE:
                    return entryVarDefinitionData.value;
                case Runtime_1.ENTRY_VAR_SOURCE.STRING:
                    return (0, entryVarEvaluateString_1.default)(entryVarDefinitionData);
                case 'self':
                case 'operator':
                case 'colorValue':
                    return entryVarDefinitionData.value;
                // text will be deprecated as well as fancyText
                case 'text':
                case 'fancyText':
                    return entryVarDefinitionData.subPath;
                // tagsString will be deprecated
                case 'tagsString': {
                    return (0, entryVarEvaluateTagString_1.default)(evaluateEntryVar, entryVarDefinitionData.subPath, entryVarDefinitionData.joiner || undefined);
                }
                case Runtime_1.ENTRY_VAR_SOURCE.LIST_ITEM_DATA: {
                    const itemContext = (0, processorGetControlListItemContextById_1.default)({
                        controlId: controlCallerId,
                        rootProcessor,
                    });
                    // console.log('itemContext', itemContext?.data)
                    // When in the context of a list item inside a list
                    if (entryVarDefinitionData.subPath) {
                        const { subAtribute } = entryVarDefinitionData.subPath;
                        if (subAtribute) {
                            if (typeof subAtribute === 'string') {
                                return (0, getValueByPathFromUnknown_1.default)(itemContext === null || itemContext === void 0 ? void 0 : itemContext.data, subAtribute.split('.'));
                            }
                            const valueFromSubAtribute = await evaluateEntryVar(subAtribute);
                            if (typeof valueFromSubAtribute === 'string') {
                                return (0, getValueByPathFromUnknown_1.default)(itemContext === null || itemContext === void 0 ? void 0 : itemContext.data, valueFromSubAtribute.split('.'));
                            }
                        }
                    }
                    return itemContext === null || itemContext === void 0 ? void 0 : itemContext.data;
                }
                case 'listItemId':
                    return (_a = (0, processorGetControlListItemContextById_1.default)({
                        controlId: controlCallerId,
                        rootProcessor,
                    })) === null || _a === void 0 ? void 0 : _a.id;
                case Runtime_1.ENTRY_VAR_SOURCE.OUT_VAR: {
                    // Should evaluate from inside the outvars
                    const functionId = (_b = entryVarDefinitionData.subPath) === null || _b === void 0 ? void 0 : _b.functionId;
                    const subAtribute = (_c = entryVarDefinitionData.subPath) === null || _c === void 0 ? void 0 : _c.subAtribute;
                    const functionOutputValue = functionId
                        ? lastFunctionsOutputs.get(functionId) : undefined;
                    if (subAtribute) {
                        if ((0, valueIsString_1.default)(subAtribute)) {
                            return (0, getValueByPathFromUnknown_1.default)(functionOutputValue, subAtribute.split('.'));
                        }
                        const prop = await evaluateEntryVar(subAtribute);
                        if ((0, valueIsString_1.default)(prop)) {
                            return (0, getValueByPathFromUnknown_1.default)(functionOutputValue, prop.split('.'));
                        }
                    }
                    return functionOutputValue;
                }
                case 'eventOutputs': {
                    const subAtribute = (_d = entryVarDefinitionData.subPath) === null || _d === void 0 ? void 0 : _d.subAtribute;
                    if (subAtribute) {
                        if (typeof subAtribute === 'string') {
                            return (0, getValueByPathFromUnknown_1.default)(eventOutputs, subAtribute.split('.'));
                        }
                        const prop = await evaluateEntryVar(subAtribute);
                        if (typeof prop === 'string') {
                            return (0, getValueByPathFromUnknown_1.default)(eventOutputs, prop.split('.'));
                        }
                    }
                    return eventOutputs;
                }
                case 'selfElement': {
                    const flattedControls = (0, appStateSelectFC_1.default)(store.getState());
                    if (!flattedControls) {
                        throw new Error('No flatted controls on processor');
                    }
                    if (!controlCallerId) {
                        throw new Error('No control caller id');
                    }
                    return elementsInstruction({
                        flattedControls,
                        controlId: controlCallerId,
                        propName: entryVarDefinitionData.property,
                    });
                }
                case 'currentPage': {
                    const appState = store.getState();
                    const flattedControls = (0, appStateSelectFC_1.default)(appState);
                    if (!flattedControls) {
                        throw new Error('No flatted controls on processor');
                    }
                    const currentPageId = (0, appStateSelectRoutingStackCurrentPageId_1.default)(appState);
                    if ((0, valueIsUndefined_1.default)(currentPageId)) {
                        return undefined;
                    }
                    return elementsInstruction({
                        flattedControls,
                        controlId: currentPageId,
                    });
                }
                case 'elements': {
                    const flattedControls = (0, appStateSelectFC_1.default)(store.getState());
                    if (!flattedControls) {
                        throw new Error('No flatted controls on processor');
                    }
                    const { subPath, property } = entryVarDefinitionData;
                    const controlId = (0, valueIsString_1.default)(subPath) ? subPath : subPath === null || subPath === void 0 ? void 0 : subPath.controlId;
                    if (!controlId) {
                        throw new Error('Invalid controlId');
                    }
                    if (property === null || property === void 0 ? void 0 : property.includes('extraData')) {
                        let path = controlId;
                        if (!(0, valueIsString_1.default)(subPath) && (subPath === null || subPath === void 0 ? void 0 : subPath.subAtribute)) {
                            const { subAtribute } = subPath;
                            if ((0, valueIsString_1.default)(subAtribute)) {
                                path = `${controlId}.${subAtribute}`;
                            }
                            else {
                                const evaluateSubAtribute = await evaluateEntryVar(subAtribute);
                                path = `${controlId}.${evaluateSubAtribute}`;
                            }
                        }
                        return (0, getValueByPathFromUnknown_1.default)(processor.root.controlsExtraData, path.split('.'));
                    }
                    return elementsInstruction({
                        flattedControls,
                        controlId,
                        propName: property,
                    });
                }
                case 'objectOfEntryVars': {
                    return (0, evaluateObjectOfEntryVars_1.default)({
                        evaluator: evaluateEntryVar,
                        entryVarsObject: entryVarDefinitionData.subPath,
                    });
                }
                case 'uuidv1':
                    return (0, uuid_1.v1)();
                case 'currentUserId': {
                    return (_e = processor.root.firebase.auth().currentUser) === null || _e === void 0 ? void 0 : _e.uid;
                }
                case 'listInstructions': {
                    // All the instructions to build a list should be passed as they are
                    const orderByField = (_g = (_f = entryVarDefinitionData.subPath) === null || _f === void 0 ? void 0 : _f.listOptions) === null || _g === void 0 ? void 0 : _g.orderByField;
                    if (!(0, valueIsUndefined_1.default)(orderByField)
                        && !(0, valueIsNull_1.default)(orderByField)) {
                        return Object.assign(Object.assign({}, entryVarDefinitionData.subPath), { listOptions: Object.assign(Object.assign({}, ((_h = entryVarDefinitionData === null || entryVarDefinitionData === void 0 ? void 0 : entryVarDefinitionData.subPath) === null || _h === void 0 ? void 0 : _h.listOptions) || {}), { orderByField: await evaluateEntryVar(orderByField) }) });
                    }
                    return entryVarDefinitionData.subPath;
                }
                case 'updatesDB': {
                    if (!entryVarDefinitionData.updates) {
                        return [];
                    }
                    const oldUpdates = entryVarDefinitionData.updates;
                    let updates = [];
                    for (let i = 0; i < oldUpdates.length; i += 1) {
                        const update = oldUpdates[i];
                        const { data, path } = update;
                        if (data) {
                            let entryVarPath = [];
                            for (let j = 0; j < path.length; j += 1) {
                                const link = path[j];
                                if (!link.itemId) {
                                    throw new Error('Error, all links on an update should have an itemId');
                                }
                                entryVarPath = [
                                    ...entryVarPath,
                                    link.collectionName,
                                    await evaluateEntryVar(link.itemId), // eslint-disable-line
                                ];
                            }
                            updates = [
                                ...updates,
                                [
                                    ...entryVarPath,
                                    await evaluateEntryVar(data), // eslint-disable-line
                                ],
                            ];
                        }
                    }
                    return updates;
                }
                case 'dbWritePath': { // Source for functions GetDataDB and DeleteDataDB
                    const pathLinks = entryVarDefinitionData.path || [];
                    const pathValues = [];
                    for (let i = 0; i < pathLinks.length; i += 1) {
                        const link = pathLinks[i];
                        pathValues.push(link.collectionName);
                        if (link.itemId) {
                            // eslint-disable-next-line no-await-in-loop
                            pathValues.push(await evaluateEntryVar(link.itemId));
                        }
                    }
                    return pathValues;
                }
                case 'dbUpdateInstruction': {
                    const updateInstructions = entryVarDefinitionData.subPath;
                    const newUpdateInstructions = await Promise.all(updateInstructions
                        .map(async (updateInstruction) => {
                        const updateInstructionPath = updateInstruction.slice(0, -1);
                        const updateFields = updateInstruction[updateInstruction.length - 1];
                        // Decides if it should generate a new uuid
                        const lastDetermining = updateInstructionPath[updateInstructionPath.length - 1];
                        if (lastDetermining.auxType === 'collection') {
                            const idEntry = {
                                source: Runtime_1.ENTRY_VAR_SOURCE.TEXT,
                                subPath: `${Date.now()}-${(0, uuid_1.v1)()}`,
                            };
                            const result = await Promise.all([
                                ...updateInstructionPath,
                                idEntry,
                                updateFields,
                            ].map(evaluateEntryVar));
                            return result;
                        }
                        const result = await Promise.all(updateInstruction.map(evaluateEntryVar));
                        return result;
                    }));
                    return newUpdateInstructions;
                }
                case 'pageTransition': {
                    const params = await (0, evaluateObjectOfEntryVars_1.default)({
                        evaluator: evaluateEntryVar,
                        entryVarsObject: entryVarDefinitionData.subPath.dataToSend || {},
                    });
                    return {
                        pageId: entryVarDefinitionData.subPath.pageId,
                        params,
                    };
                }
                case 'appRuntimeData':
                case 'pageInputData': {
                    return (0, entryVarEvaluatorContextInputData_1.default)({
                        store,
                        entryVar: entryVarDefinitionData,
                        evaluateEntryVar,
                        processor,
                    });
                }
                case 'relational': {
                    const operator = await evaluateEntryVar(entryVarDefinitionData.operator);
                    const value1 = await evaluateEntryVar(entryVarDefinitionData.value1);
                    const value2 = await evaluateEntryVar(entryVarDefinitionData.value2);
                    switch (operator) {
                        case '===':
                            return value1 === value2;
                        default:
                            throw new Error(`No valid relational operator [${operator}]`);
                    }
                }
                case 'ifStatement': {
                    const conditionResult = await evaluateEntryVar(entryVarDefinitionData.value.condition);
                    const result = conditionResult
                        ? await evaluateEntryVar(entryVarDefinitionData.value.trueResult)
                        : await evaluateEntryVar(entryVarDefinitionData.value.falseResult);
                    return result;
                }
                case 'currentTimestamp':
                    return Date.now();
                case 'email':
                    return (0, getValueByPathFromUnknown_1.default)(rootProcessor, ['userInfo', 'email']);
                case 'name': {
                    return (0, getValueByPathFromUnknown_1.default)(rootProcessor, ['userInfo', 'name']);
                }
                case 'userPhone': {
                    return (0, getValueByPathFromUnknown_1.default)(rootProcessor, ['userInfo', 'phone']);
                }
                case 'currentUserProfilePicUrl': {
                    return (0, getValueByPathFromUnknown_1.default)(rootProcessor, ['userInfo', 'photoURL']);
                }
                case 'userCustomData': {
                    return (0, getValueByPathFromUnknown_1.default)(rootProcessor, ['userInfo', 'customData', entryVarDefinitionData.value]);
                }
                case Runtime_1.ENTRY_VAR_SOURCE.CALLABLE: {
                    const completeProcessor = Object.assign(Object.assign({}, processor), { evaluateVarFactory: evaluatorWithProcessor });
                    return (0, entryVarEvaluateCallback_1.default)({
                        store,
                        entryVar: entryVarDefinitionData,
                        functionsDefinitions,
                        processor: completeProcessor,
                        controlCallerId,
                        eventOutputs,
                    });
                }
                case Runtime_1.ENTRY_VAR_SOURCE.COMPUTE_FUNCTION: {
                    const completeProcessor = Object.assign(Object.assign({}, processor), { evaluateVarFactory: evaluatorWithProcessor });
                    const result = (0, buildFunctionEvaluator_1.default)({
                        store,
                        processor: completeProcessor,
                        functionEntryVar: entryVarDefinitionData,
                        controlCallerId,
                        eventOutputs,
                        lastFunctionsOutputs,
                        functionsDefinitions,
                    });
                    return result;
                }
                default:
                    throw new Error(`
                    The source instruction [${entryVarDefinitionData.source}] is not a valid instruction
                    entry var: ${JSON.stringify(entryVarDefinitionData)}
                `);
            }
        };
        return evaluateEntryVar;
    };
    return evaluatorWithProcessor;
};
exports.default = evaluateVarFactoryWithProcessor;
